/* Grail Nation — Saves + Wants (v11, Oct 23 2026)
   Phase 1: saves are kept on this device (localStorage), keyed by product handle.
   Card heart sits beside the product name, below the photo. */
(() => {
  if (window.GNWants) return;
  const KEY = 'gn_wants_v1';
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const WANTS_URL = ROOT + 'pages/wants';
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  const read = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter((x) => x && typeof x.h === 'string') : [];
    } catch (e) { return []; }
  };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} };
  const has = (h) => read().some((x) => x.h === h);

  function toggle(h) {
    const list = read();
    const i = list.findIndex((x) => x.h === h);
    let saved;
    if (i > -1) { list.splice(i, 1); saved = false; }
    else { list.unshift({ h, t: Date.now() }); saved = true; }
    write(list);
    refresh();
    document.dispatchEvent(new CustomEvent('gn:wants-change', { detail: { handle: h, saved, count: list.length } }));
    return saved;
  }

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const handleFromHref = (href) => {
    if (!href) return null;
    const m = href.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };
  const money = (cents) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  const imgUrl = (src, w) => {
    if (!src) return '';
    const s = src.startsWith('//') ? 'https:' + src : src;
    return s + (s.includes('?') ? '&' : '?') + 'width=' + w;
  };

  function iconButton(h, title) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'gn-save gn-save--icon';
    b.dataset.gnSave = h;
    b.setAttribute('aria-pressed', 'false');
    b.setAttribute('aria-label', 'Save ' + (title || 'this pair') + ' to Wants');
    b.innerHTML = HEART;
    return b;
  }

  function fullButton(h) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'gn-save gn-save--full';
    b.dataset.gnSave = h;
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML = HEART + '<span data-gn-save-label>Save to Wants</span>';
    return b;
  }

  function decorateCards(root) {
    (root || document).querySelectorAll('hdt-card-product, .hdt-card-product').forEach((card) => {
      const media = card.querySelector('.hdt-card-product__content') || card.querySelector('.hdt-card-product__media');
      if (!media || card.querySelector('.gn-save')) return;
      const link = card.querySelector('a[data-pr-url], a[href*="/products/"]');
      const h = handleFromHref(link && link.getAttribute('href'));
      if (!h) return;
      const title = (card.querySelector('.hdt-card-product__title a') || {}).textContent;
      const btn = iconButton(h, title && title.trim());
      btn.classList.add('gn-save--card');
      media.classList.add('gn-has-save');
      media.appendChild(btn);
    });
  }

  function decorateProductPage() {
    const h = window.GN_PRODUCT_HANDLE;
    if (!h || document.querySelector('.gn-save--full')) return;
    const info = document.querySelector('#MainContent .hdt-product__info-container');
    if (!info) return;
    const add = info.querySelector('button[name="add"]');
    let anchor = add;
    while (anchor && anchor.parentElement !== info) anchor = anchor.parentElement;
    const wrap = document.createElement('div');
    wrap.className = 'gn-save-wrap hdt-product-info__item';
    wrap.appendChild(fullButton(h));
    if (anchor) anchor.insertAdjacentElement('afterend', wrap);
    else info.appendChild(wrap);
  }

  function decorateHeader() {
    document.querySelectorAll('.hdt-header__utilities').forEach((u) => {
      if (u.querySelector('.gn-wants-link')) return;
      const a = document.createElement('a');
      a.href = WANTS_URL;
      a.className = 'gn-wants-link hdt-relative';
      a.setAttribute('aria-label', 'Wants');
      a.innerHTML = HEART + '<span class="gn-wants-count" data-gn-wants-count hidden>0</span>';
      const cart = u.querySelector('.hdt-cart-icon');
      if (cart) u.insertBefore(a, cart); else u.appendChild(a);
    });
  }

  function refresh() {
    const set = new Set(read().map((x) => x.h));
    document.querySelectorAll('[data-gn-save]').forEach((b) => {
      const on = set.has(b.dataset.gnSave);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-saved', on);
      const label = b.querySelector('[data-gn-save-label]');
      if (label) label.textContent = on ? 'Saved' : 'Save to Wants';
    });
    document.querySelectorAll('[data-gn-wants-count]').forEach((el) => {
      el.textContent = set.size > 99 ? '99+' : String(set.size);
      el.hidden = set.size === 0;
    });
  }

  let toastEl, toastTimer;
  function toast(saved) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'gn-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = saved
      ? '<span>Saved to Wants</span><a href="' + WANTS_URL + '">View</a>'
      : '<span>Removed from Wants</span>';
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  }

  const cache = new Map();
  async function fetchProduct(h) {
    if (cache.has(h)) return cache.get(h);
    let out;
    try {
      const r = await fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } });
      out = r.status === 404 ? { gone: true } : r.ok ? { p: await r.json() } : { err: true };
    } catch (e) { out = { err: true }; }
    if (!out.err) cache.set(h, out);
    return out;
  }

  function sizesOf(p) {
    const idx = (p.options || []).findIndex((o) => /size/i.test(typeof o === 'string' ? o : o.name));
    if (idx < 0) return [];
    const key = 'option' + (idx + 1);
    const seen = new Set();
    (p.variants || []).forEach((v) => { if (v.available && v[key]) seen.add(v[key]); });
    return [...seen];
  }

  function cardHTML(p) {
    const url = ROOT + 'products/' + p.handle;
    const onSale = p.compare_at_price && p.compare_at_price > p.price;
    const sizes = sizesOf(p);
    return (
      '<article class="gn-want' + (p.available ? '' : ' is-soldout') + '">' +
        '<a class="gn-want__media" href="' + url + '">' +
          (p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 600)) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') +
          (p.available ? '' : '<span class="gn-want__badge">Sold out</span>') +
          (p.available && onSale ? '<span class="gn-want__badge gn-want__badge--sale">Sale</span>' : '') +
        '</a>' +
        '<button type="button" class="gn-save gn-save--icon is-saved" aria-pressed="true" data-gn-save="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + ' from Wants">' + HEART + '</button>' +
        '<div class="gn-want__body">' +
          (p.vendor ? '<p class="gn-want__brand">' + esc(p.vendor) + '</p>' : '') +
          '<a class="gn-want__title" href="' + url + '">' + esc(p.title) + '</a>' +
          '<p class="gn-want__price">' +
            '<span class="' + (onSale ? 'is-sale' : '') + '">' + (p.price_varies ? 'From ' : '') + money(p.price) + '</span>' +
            (onSale ? '<s>' + money(p.compare_at_price) + '</s>' : '') +
          '</p>' +
          (sizes.length ? '<p class="gn-want__sizes"><span>In stock:</span> ' + sizes.map((s) => '<span class="gn-chip">' + esc(s) + '</span>').join('') + '</p>' : '') +
          '<a class="gn-btn gn-btn--solid" href="' + url + '">' + (p.available ? 'Shop now' : 'View pair') + '</a>' +
        '</div>' +
      '</article>'
    );
  }

  let rendering = false;
  async function renderWants() {
    const grid = document.getElementById('gn-wants-grid');
    if (!grid || rendering) return;
    rendering = true;
    const empty = document.getElementById('gn-wants-empty');
    const total = document.getElementById('gn-wants-total');
    const list = read();
    if (total) total.textContent = String(list.length);
    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      rendering = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (!grid.children.length) grid.innerHTML = list.map(() => '<div class="gn-want gn-want--skeleton"></div>').join('');
    grid.setAttribute('aria-busy', 'true');
    const results = await Promise.all(list.map((x) => fetchProduct(x.h).then((r) => ({ h: x.h, ...r }))));
    const gone = results.filter((r) => r.gone).map((r) => r.h);
    if (gone.length) write(read().filter((x) => !gone.includes(x.h)));
    const items = results.filter((r) => r.p);
    grid.innerHTML = items.map((r) => cardHTML(r.p)).join('');
    grid.removeAttribute('aria-busy');
    if (total) total.textContent = String(read().length);
    if (!items.length && empty) empty.hidden = false;
    rendering = false;
    refresh();
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-gn-save]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toast(toggle(b.dataset.gnSave));
  }, true);

  document.addEventListener('gn:wants-change', () => {
    if (document.getElementById('gn-wants-grid')) renderWants();
  });

  window.addEventListener('storage', (e) => {
    if (e.key !== KEY) return;
    refresh();
    renderWants();
  });

  let moTimer;
  const mo = new MutationObserver(() => {
    clearTimeout(moTimer);
    moTimer = setTimeout(() => { decorateCards(); decorateHeader(); refresh(); }, 120);
  });

  function init() {
    decorateHeader();
    decorateCards();
    decorateProductPage();
    refresh();
    renderWants();
    mo.observe(document.body, { childList: true, subtree: true });
  }

  window.GNWants = { list: () => read().map((x) => x.h), has, toggle, refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
